import {
    Component, ViewChild, Input, Output, ElementRef, ChangeDetectorRef, Inject, EventEmitter,
    AfterViewInit, ViewChildren, OnInit
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';

import { UpdateFieldTypes, UpdateFieldConstants } from '../master-common.model';

import { CurrencyMaskInputMode } from "ngx-currency";

import * as moment from 'moment';

declare var abp: any;

// @dynamic
@Component({
    selector: 'app-update-field',
    templateUrl: './update-field.component.html',
    styleUrls: ['./update-field.component.less'],
    exportAs: 'updatefield'
})
export class UpdateFieldComponent implements AfterViewInit, OnInit {
    @ViewChild('controlRef', { static: true }) controlRef: ElementRef;
    @ViewChild('mainDivRef', { static: true }) mainDivRef: ElementRef;

    @ViewChildren('mainDivOneClickRef') mainDivOneClickRef: ElementRef;
    
    @Output() updateFieldOutputValue = new EventEmitter();

    @Input()
    isRequired: boolean = false;

    @Input()
    ValidateMessage: string;

    @Input()
    fieldType: UpdateFieldTypes;

    @Input()
    placeHolder: string;

    @Input()
    isTable: boolean = false;

    @Input()
    value: any = null;

    @Input()
    options: any;

    @Input()
    dateFormat = 'DD-MM-YYYY';

    @Input()
    rows = 2;

    @Input()
    cols = 15;

    @Input()
    originalValue: any;

    @Input()
    isPencilVisible: boolean = false;

    @Input()
    suffixSign: string = ' Eur';

    @Input()
    maxDate: Date = null;

    @Input()
    editAbsolute: boolean = false;

    @Input()
    isPercentageValue: boolean = false;

    // Variable to store uuid number
    uuid: number;

    currency: any;

    DEFAULT_DATE_FORMAT: string = 'DD-MM-YYYY';

    // Form controls
    updateFieldFormControls: FormControl;

    currentClass: string;
    // Public variables
    isEditMode = false;
    oldValue: string;
    UpdateFieldTypes: typeof UpdateFieldTypes = UpdateFieldTypes;
    constructor(private changeDetector: ChangeDetectorRef, @Inject(DOCUMENT) document) {

        this.currentClass = UpdateFieldConstants.updateFieldDefaultClassName;
    }

    ngOnInit(): void {
        if (this.fieldType === UpdateFieldTypes.Date) {
            if (!this.value || this.value === "0001-01-01") {
                this.value = new Date();
            }
        }

        if (this.fieldType === UpdateFieldTypes.Currency) {
            if (!this.value ) {
                this.value = 0;
            }
        }
    }

    ngAfterViewInit() {
        if (this.isRequired === true) {
            this.updateFieldFormControls = new FormControl('', Validators.required);
        } else {
            this.updateFieldFormControls = new FormControl('');
        }
    }

    emitUpdateFieldValue(val?: any) {
        if (this.value === null) {
            let value = val as string || '';
            this.updateFieldOutputValue.emit(value);
        } else {
            this.updateFieldOutputValue.emit(this.value);
        }
    }

    getZeroValue(val?: any): number | string {
        if (val) {
            if (val == 0 || val == '0') {
                return 0;
            }
        }
        return '0';
    }

    get currentLocale(): string {
        let localization = abp.localization as any;
        let cultureName = localization.currentCulture.name;
        return cultureName;
    }

    getClass(): string {
        if (this.value !== this.originalValue) {
            return 'update-field-modified';
        }

        return '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public events
    // -----------------------------------------------------------------------------------------------------


    //#region Date Field

    onDateChangeEnd(value: Date): void {
        setTimeout(() => {
            this.isEditMode = false;

            //update property
            this.onClickSave();

        }, 150);
    }


    onDatepickerValueChange(value: Date): void {
        this.value = value;
    }
    //#endregion Date Field


    onClickEdit() {
        this.uuid = new Date().getTime();
        this.oldValue = this.value;
        this.isEditMode = true;
        /** Set active to current component**/
        this.currentClass = UpdateFieldConstants.updateFieldActiveControlClassName;

        this.changeDetector.detectChanges();

        if (this.fieldType === UpdateFieldTypes.Radio || this.fieldType === UpdateFieldTypes.Checkbox) {
            const radioElemObj = this.controlRef.nativeElement.querySelectorAll('.update-field');
            if (radioElemObj.length > 0) {
                radioElemObj[0].focus();
            }
        } else if (this.fieldType === UpdateFieldTypes.Date) {
            // Trigger click event of field to show the datepicker by default and set focus.
            if (this.value) {
                if (typeof (this.value) === 'string') {
                    const objDate = moment(this.value).format(this.dateFormat);
                    this.updateFieldFormControls.setValue(objDate);
                } else {
                    this.updateFieldFormControls.setValue(this.value);
                }
            }
            if (this.controlRef && this.controlRef.nativeElement) {
                this.controlRef.nativeElement.focus();
                this.controlRef.nativeElement.click();
            }
        } else {
            this.updateFieldFormControls.setValue(this.value);

            if (this.controlRef && this.controlRef.nativeElement) {
                this.controlRef.nativeElement.focus();
            }

            let ref = this.mainDivOneClickRef as any;
            let refNatEl = ref.first.nativeElement;
            if (ref && refNatEl) {
                refNatEl.focus();
                this.focus(refNatEl);
            }
        }
    }

    onClickCancel() {
        this.value = this.oldValue;
        this.isEditMode = false;

        this.currentClass = UpdateFieldConstants.updateFieldDefaultClassName;

        this.emitUpdateFieldValue();
    }

    onClickDown(parentDivRef) {
        this.value = this.oldValue;
        this.isEditMode = false;

        this.currentClass = UpdateFieldConstants.updateFieldDefaultClassName;

        const nextElementRef = this.getNextElement(parentDivRef);
        const isNextElementActive = nextElementRef.classList.contains(UpdateFieldConstants.activeFieldClassName);
        this.emitUpdateFieldValue();
        if (!isNextElementActive) {
            nextElementRef.click();
        } else {
            const updateFieldObj = nextElementRef.querySelectorAll('.' + UpdateFieldConstants.fieldClassName);
            if (updateFieldObj.length > 0) {
                updateFieldObj[0].focus();
            }
        }
    }


    onClickUp(parentDivRef) {
        this.value = this.oldValue;
        this.isEditMode = false;

        this.currentClass = UpdateFieldConstants.updateFieldDefaultClassName;

        const prevElementRef = this.getPrevElement(parentDivRef);
        const isNextElementActive = prevElementRef.classList.contains(UpdateFieldConstants.activeFieldClassName);
        this.emitUpdateFieldValue();
        if (!isNextElementActive) {
            prevElementRef.click();
        } else {
            const updateFieldObj = prevElementRef.querySelectorAll('.' + UpdateFieldConstants.fieldClassName);
            if (updateFieldObj.length > 0) {
                updateFieldObj[0].focus();
            }
        }
    }

    onClickSave() {
        if (this.fieldType === UpdateFieldTypes.Number) {
            if (isNaN(this.fieldType)) {
                this.value = null;
            } else {
                this.value = this.updateFieldFormControls.value;
            }
        } else if (this.fieldType === UpdateFieldTypes.Date) {
            this.value = this.updateFieldFormControls.value;
        } else if (this.fieldType === UpdateFieldTypes.Dropdown) {
            //this.value = this.updateFieldFormControls.value;
        } else if (this.fieldType === UpdateFieldTypes.Currency) {
            this.value = parseFloat(this.updateFieldFormControls.value).toFixed(this.precision);
        } else if (this.fieldType !== UpdateFieldTypes.Radio && this.fieldType !== UpdateFieldTypes.Checkbox) {
            this.value = this.updateFieldFormControls.value;
        }

        this.currentClass = UpdateFieldConstants.updateFieldDefaultClassName;
        this.isEditMode = false;
        this.emitUpdateFieldValue(this.value);

        if (this.fieldType !== UpdateFieldTypes.Date) {
            this.updateFieldFormControls.setValue(null);
        }
    }

    onFocusOut(event) {
        if(this.fieldType !== UpdateFieldTypes.Date){
            setTimeout(()=>{
                this.isEditMode = false;
            }, 150);
        }

        if(this.fieldType == UpdateFieldTypes.Currency){
            setTimeout(()=> {
                let value = this.updateFieldFormControls.value;;
                this._truncatePrecision(value);
            }, 1);
        }
    }

    onClickTab(parentDivRef) {
        const nextElementRef = this.getNextElement(parentDivRef);
        const isNextElementActive = nextElementRef.classList.contains(UpdateFieldConstants.activeFieldClassName);
        this.onClickSave();

        if (!isNextElementActive) {
            nextElementRef.click();
        } else {
            this.focus(nextElementRef);
        }
    }

    focus(nextElementRef: any) {
        const updateFieldObj = nextElementRef.querySelectorAll('.' + UpdateFieldConstants.fieldClassName);
        if (updateFieldObj.length > 0) {
            updateFieldObj[0].focus();
            //with select
            updateFieldObj[0].select();
        }
    }

    onChangeCheckbox(event, item) {
        if (event.target.checked) {
            if (this.value) {
                this.value.push(item.value);
            } else {
                this.value = new Array();
                this.value.push(item.value);
            }
        } else {
            const index = this.value.findIndex(x => x === item.value);
            this.value.splice(index, 1);
        }
    }

    checkBoxState(item) {
        if (!this.value) {
            return false;
        }
        const index = this.value.findIndex(x => x === item.value);
        if (index >= 0) {
            return true;
        } else {
            return false;
        }
    }

    onChangeRadio(item) {
        this.value = item.value;
    }

    onChangeText(item){
        this.value = item.value;
    }

    onChangeDropdown(item) {
        this.value = item.target.value;
    }


    getNextElement(parentDivRef) {

        let next;
        const divs = document.getElementsByClassName(UpdateFieldConstants.updateFieldMainDivClassName);
        for (let i = 0; i < divs.length; i++) {
            if (divs[i] === parentDivRef) {
                next = divs[i + 1];
                break;
            }
        }
        return next;
    }

    getPrevElement(parentDivRef) {

        let prev;
        const divs = document.getElementsByClassName(UpdateFieldConstants.updateFieldMainDivClassName);
        for (let i = 0; i < divs.length; i++) {
            if (divs[i] === parentDivRef) {
                prev = divs[i - 1];
                break;
            }
        }
        return prev;
    }

    get financialCurrencyMode() {
        return CurrencyMaskInputMode.FINANCIAL;
    }

    get naturalCurrencyMode() {
        return CurrencyMaskInputMode.NATURAL;
    }


    _precision = 2;
    get precision(): number {
        return this._precision;
    }

    getPrecision(newValue: any): void {
        let precision = newValue.toString();

        if (precision.includes('.')) {
            let length = precision.split('.')[1].length;

            if (length <= 2) {
                this._precision = 2;
                return;
            }

            if (length >= 5) {
                this._precision = 5;
                return;
            }

            this._precision = length;
            return;
        }

        this._precision = 2;
    }

    _newChar: any = null;
    onKeyDown(event, parentDivRef) {
        if (this.fieldType === UpdateFieldTypes.Currency) {
            this._onKeyDownCurrency(event);
            this._newChar = String.fromCharCode(event.keyCode);
        }

        if (event.keyCode === 27) {
            this.onClickCancel();
        } else if (event.keyCode === 13) {
            this.onClickSave();
        } else if (event.keyCode === 9) {
            if(!this.isTable){
                event.preventDefault();
                this.onClickTab(parentDivRef);
            }else{
                this.isEditMode = false;
            }
        } else if (event.keyCode === 38) {
            this.onClickUp(parentDivRef);
        } else if (event.keyCode === 40) {
            this.onClickDown(parentDivRef);
        }
    }

    _cursorPosition: any;
    private _onKeyDownCurrency(event){
        // if (this.fieldType === UpdateFieldTypes.Currency)
        // if cursor at the end+
        // if char is number+
        // if precision < 5 +
        // then increase precision
        const input: any = this.currencyInput;

        let value = input.value;
        if (this._isBackspace(event)) {

            if (this.suffixSign) {
                let suffixLength = this.suffixSign.length;
                value = `${value.substring(0, value.length-suffixLength)}`;
            }
            let newLength = value.length - 1;
            if (!this._isCursorAtPosition(input, newLength, true)) {
                return;
            }

            value = value.slice(0, newLength);
            this._updateInput(input, value);
            return;
        }

        if (!this._isCursorAtPosition(input, input.value.length)) {
            return;
        }

        if (!this._isNumberChar(event)) {
            return;
        }

        if (this._precision >= 5) {
            return;
        }

        let newChar = this._newChar = String.fromCharCode(event.keyCode);
        if (this.suffixSign) {
            let suffixLength = this.suffixSign.length;
            value = `${input.value.substring(0, input.value.length-suffixLength)}${newChar}`;
        } else {
            value = input.value + newChar;
        }

        this._updateInput(input, value, true);
    }

    private _updateInput(input, value, cursorToEnd = false) {
        this.getPrecision(value);

        event.stopPropagation();
        event.preventDefault();

        //wait for precision to add extra 0 and after call set new value method
        setTimeout(() => {
            this.updateFieldFormControls.setValue(value);
            if (cursorToEnd) {
                let position = this._cursorPosition;
                input.setSelectionRange(position, position);
            }
        }, 1); 
    }

    private _truncatePrecision(value) {
        if (!value) {
            return;
        }

        if (value == 0 || value == '0') {
            this._precision = 2;
            return;
        }

        let precision = this._getDecimalPartLength(value);
        if (precision != this._precision) {
            this.getPrecision(value);
            return;
        }

        let lastChar = value.toString().slice(-1);
        if (lastChar == 0 || lastChar == '0') {
            this.getPrecision(value);
        }
    }

    private _getDecimalPartLength(value): number {
        return value.toString().split('.')[1].length;
    }

    private _isBackspace(event) {
        return event.keyCode === 8;
    }

    private _isNumberChar(event) {
        return (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) ;
    }

    private _isCursorAtPosition(input, position, isBackSpace = false) {
        let selectionStart = input.selectionStart;
        this._cursorPosition = selectionStart + 1;
        let selectionEnd = input.selectionEnd;
        if (selectionStart !== selectionEnd) {
            return false;
        }

        if (this.suffixSign && !isBackSpace) {
            position = position - this.suffixSign.length;
        }
        if (selectionStart !== position) {
            return false;
        }
        return true;
    }

    get currencyInput() {
        var input: any = document.getElementById('currencyInput');
        return input;
    }

    get currencyInputValue(): string {
        return this.currencyInput.value;
    }
}

